import { useGlobalState } from '@/hooks';
import type { ContentItemInterface } from '@/interfaces';
import Arrow from '../../../../public/images/icons/arrow_forward.svg';
import { BulletPontContainer, ContentWrapper, HyperLink, ImageWrapper, SubTitle, Title } from './BulletPoints.styles';

const BulletPoints: React.FC<ContentItemInterface> = ({ title, subTitle, buttonText, buttonLink, openInNewTab }) => {
  const { t } = useGlobalState();
  const translatedTitle = t(title ?? '');
  const translatedSubTitle = t(subTitle ?? '');
  const translatedButtonText = t(buttonText ?? '');
  return (
    <>
      <BulletPontContainer>
        <ImageWrapper>
          <Arrow width='24' height='24' />
        </ImageWrapper>
        <ContentWrapper>
          <Title>{translatedTitle}</Title>
          <SubTitle>{translatedSubTitle}</SubTitle>
          <HyperLink href={buttonLink} openInNewTab={openInNewTab}>
            {translatedButtonText}
          </HyperLink>
        </ContentWrapper>
      </BulletPontContainer>
    </>
  );
};

export default BulletPoints;
